import UserServiceClient from "app/clients/userService";

export const fetchCandidatesAPI = (data) => {
  return UserServiceClient.post(`/get-candidates`, data)
}